import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { DataService } from '../../services/data.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-atypes',
  templateUrl: './atypes.component.html',
  styleUrls: ['./atypes.component.css']
})
export class AtypesComponent implements OnInit {

  @Output() listChanged = new EventEmitter();
  @Input() buttonMode = false;
  @Input() isAttentionTurn = false;
  @Input() selectedTurn: any;

  private destroy$ = new Subject();

  atypes: any;
  category: number;
  turn: boolean = false;

  public search: string = '';
  public listFilter: any = { name: '' };

  constructor(private _blogic: BusinesLogicService,
    public _data: DataService,
    private _utils: UtilsService) {
    this.atypes = (this._data.configuration["closeOnlyQueueKind"])
      ? (this._data.turn && this._data.turn["queue_id"]) ? this.getFilterKind(this._data.turn["queue_id"]) : this._data.session["atypes"]
      : this._data.session["atypes"];
  }

  ngOnInit() {
    this._updateTurn(this._data.turn);
    this._data.turnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._updateTurn(response);
        }
      );

      if (localStorage.getItem("searchkind") != null) {
        this.search = localStorage.getItem("searchkind");
        this.searchFilter();
      }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public getFilterKind(id: number) {
    return this._data.session["atypes"].filter(x => x.queue_id == id);
  }

  /* Close current turn */
  public close(id: number) {
    let params = {
      desk_id: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["desk_id"] : this._data.session["desk"],
      status: "I",
      turn_id: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["id"] : this._data.turn["id"],
      ticket: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["num"] : this._data.turn["num"],
      label: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["label"] :  this._data.turn["label"],
      queue_id: (this.selectedTurn && this.isAttentionTurn) ? this.selectedTurn["queue_id"] : this._data.turn["queue_id"],
      session_id: this._data.session["id"],
      kind_id: id,
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"]
    }

    this._blogic.deskNotify(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          if (this._data.session["wmode"] == 'A') {
            this.listChanged.emit(true);
            this._call();
          } else {
            this._data.closeTurn();
          }
        }
      );
  }

  getPrekindId(): any {
    if (this.selectedTurn && this.isAttentionTurn) {
      return this.selectedTurn['prekind_id'];
    }
    return this._data.turn['prekind_id'];
  }

  /* When the turn information change */
  private _updateTurn(turn: object): void {
    if (this._data.turnIsActive()) {
      this.turn = true;
      this.category = this._data.turn['category'];
    } else {
      this.turn = false;
    }
  }

  searchFilter() {
    this.listFilter = {
      $or: [{ name: this.search }]
    };

    localStorage.setItem("searchkind", this.search);
  }

  removeSearch() {
    this.search = "";
    localStorage.removeItem("searchkind");
    this.searchFilter();
  }

  /* Call a new turn */
  private _call(): void {
    let params: object = {
      desk_id: this._data.session["desk"],
      status: "A",
      deskuser: this._data.session["username"],
      deskoperator: this._data.session["operator"],
    };

    this._blogic.deskNotify(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.listChanged.emit(true);
          if (response == null) {
            this._data.closeTurn();
          } else {
            this._data.turn = response;
          }
        }
      );
  }

  orderedAtypes() {
    return this.atypes.sort(function(a, b) {
      return a.place - b.place;
  });
  }

}
